export default "__VITE_ASSET__DwtGjGHG__"